import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import { useStyles } from './styles'
import { formatDateTime, isHttpsUrl } from './utils'

const RequestResponse = ({ request }) => {
  const classes = useStyles()
  const { response } = request

  if (!response) return null

  return (
    <Box className={classes.card}>
      <Typography className={classes.cardTitle}>Your analysis</Typography>
      {response.videoUrl ? (
        // eslint-disable-next-line jsx-a11y/media-has-caption
        <video
          className={classes.video}
          src={response.videoUrl}
          poster={response.thumbnailUrl || undefined}
          controls
          playsInline
        />
      ) : null}
      {isHttpsUrl(response.onformUrl) ? (
        <Button
          variant="outlined"
          color="primary"
          component="a"
          href={response.onformUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Open analysis in Onform
        </Button>
      ) : null}
      {response.notes ? (
        <Typography className={classes.notes} style={{ marginTop: 16 }}>
          {response.notes}
        </Typography>
      ) : null}
      {response.sharedAt ? (
        <Typography className={classes.helper} style={{ marginTop: 16 }}>
          Shared {formatDateTime(response.sharedAt)}
        </Typography>
      ) : null}
    </Box>
  )
}

RequestResponse.propTypes = {
  request: PropTypes.shape({
    response: PropTypes.shape({
      videoUrl: PropTypes.string,
      onformUrl: PropTypes.string,
      thumbnailUrl: PropTypes.string,
      notes: PropTypes.string,
      sharedAt: PropTypes.string,
    }),
  }).isRequired,
}

export default RequestResponse
